export default __webpack_public_path__ + "static/media/Common Area 1.efaaa5d4.jpg";